import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.store('organizationId', 'Organization', 'organizations')
      .multi(true),
    filter
      .options.list('viewdir', 'Embed', EMBED_OPTIONS)
      .multi(false)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
  ], [])
}

const EMBED_OPTIONS = [
  { label: 'True', value: '"embed"' },
  { label: 'False', value: '{"not":"embed"}' },
]
